module.exports = __webpack_public_path__ + "img/Feature.4e35ce40.png";